// extracted by mini-css-extract-plugin
module.exports = {"blogPostDate":"blogPost-module--blogPostDate--3KazF"};